import { DISCORD_URL } from 'features/pages/slice';

import {
  Heading,
  Image,
  LinkWithButtonStyles,
} from '@frontendmentorio/design-system-v2';

export default function Discord() {
  return (
    <div className="bg-no-repeat bg-blue-600 [background-image:url('/static/images/bg-discord.svg')] [background-position:top_10%_right_-4rem] container-xl flex flex-col gap-6 items-center rounded-xl px-5 py-8 text-center text-white">
      <Image
        alt=""
        height={32}
        src="/static/images/logo-discord.svg"
        width={166}
      />

      <Heading className="tracking-widest" level="2">
        Join our Discord community
      </Heading>

      <p className="max-w-prose text-xl">
        Join thousands of Frontend Mentor community members taking the
        challenges, sharing resources, helping each other, and chatting about
        all things front-end!
      </p>

      <LinkWithButtonStyles
        className="text-blue-600"
        href={DISCORD_URL}
        level="tertiary"
      >
        Join our Discord
      </LinkWithButtonStyles>
    </div>
  );
}
